import React from "react";
import { Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Button, Row, Col } from 'react-bootstrap';


const ReportForm = () => {
  return (
    <div className=" mt-5">
      <div className="row justify-content-left">
        <div className="col-md-8">
          <h2 className="text-left mb-4" style={{ color: 'black' }}>Report Parameters</h2>
          <Form action="/lab/reports/view/report/open-tasks" method="get" id="report_open_tasks" acceptCharset="utf-8" className="p-4 border rounded" style={{ borderTop: '5px solid rgb(0, 123, 255)' }}>
            
            <Form.Group as={Row} controlId="report_open_tasks_practice">
              <Form.Label column md={4}>Accounts</Form.Label>
              <Col md={8}>
                <Form.Control as="select" name="practice" defaultValue="">
                  <option value="">Select Account</option>
                  <option value="71159">ALL SAINTS DENTAL</option>
                  <option value="12345">SAMPLE PRACTICE</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="report_open_tasks_provider_container">
              <Form.Label column md={4}>Providers</Form.Label>
              <Col md={8}>
                <Form.Control as="select" name="provider"  defaultValue="">
                  <option value="">Select Providers</option>
                  <option value="1">Provider One</option>
                  <option value="2">Provider Two</option>
                  <option value="3">Provider Three</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="report_open_tasks_account_tags">
              <Form.Label column md={4}>Account Tags</Form.Label>
              <Col md={8}>
                <Form.Control as="select" name="tags" defaultValue="">
                  <option value="">Select Account Tags</option>
                  <option value="a-practices">a-practices</option>
                  <option value="b-practices">b-practices</option>
                  <option value="c-practices">c-practices</option>
                  <option value="d-practices">d-practices</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="report_open_tasks_case_tags">
              <Form.Label column md={4}>Case Tags</Form.Label>
              <Col md={8}>
                <Form.Control as="select" name="case_tags"  defaultValue="">
                  <option value="">Select Case Tags</option>
                  <option value="none">none</option>
                  <option value="primescan">primescan</option>
                  <option value="xyz">XYZ</option>
                  <option value="urgent">urgent</option>
                  <option value="review">review</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="incomplete_task_procedure">
              <Form.Label column md={4}>Procedure</Form.Label>
              <Col md={8}>
                <Form.Control as="select" name="procedure" defaultValue="">
                  <option value="">Select Procedure</option>
                  <option value="316">1-7 ALIGNERS (DUAL ARCH)</option>
                  <option value="317">8-14 ALIGNERS (DUAL ARCH)</option>
                  <option value="318">15-22 ALIGNERS (DUAL ARCH)</option>
                  <option value="319">23-30 ALIGNERS (DUAL ARCH)</option>
                  <option value="320">31-38 ALIGNERS (DUAL ARCH)</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="open_tasks_group">
              <Form.Label column md={4}>Group</Form.Label>
              <Col md={8}>
                <Form.Control as="select" name="group" defaultValue="">
                  <option value="">Select Group</option>
                  <option value="dept">By Department</option>
                  <option value="team">By Team</option>
                  <option value="individual">By Individual</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="open_tasks_color">
              <Form.Label column md={4}>Color</Form.Label>
              <Col md={8}>
                <Form.Control as="select" name="color" defaultValue="">
                  <option value="">Select Color</option>
                  <option value="black">black</option>
                  <option value="blue">blue</option>
                  <option value="red">red</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="status">
              <Form.Label column md={4}>Status</Form.Label>
              <Col md={8}>
                <Form.Control as="select" name="status" defaultValue="">
                  <option value="">Select Status</option>
                  <option value="on_time">Only On Time</option>
                  <option value="both">On Time and Late</option>
                  <option value="past_due">Only Late</option>
                  <option value="pending">Pending</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="limit_date">
              <Form.Label column md={4}>Limit Date</Form.Label>
              <Col md={8}>
                <Form.Control as="select" name="limit_date" defaultValue="">
                  <option value="">No Limit</option>
                  <option value="2024-01-01">2024-01-01</option>
                  <option value="2024-06-01">2024-06-01</option>
                  <option value="2024-12-31">2024-12-31</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="open-tasks-start-date">
              <Form.Label column md={4}>Start Date <span className="text-danger">*</span></Form.Label>
              <Col md={8}>
                <Form.Control type="date" name="start_date" defaultValue="2024-08-01" required />
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="open-tasks-end-date">
              <Form.Label column md={4}>End Date <span className="text-danger">*</span></Form.Label>
              <Col md={8}>
                <Form.Control type="date" name="end_date" defaultValue="2024-08-31" required />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Form.Label column md={4}></Form.Label>
              <Col md={8}>
                <Form.Check
                  type="checkbox"
                  name="include_complete"
                  id="open_tasks_include_complete"
                  label="Include Completed Tasks"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="task">
              <Form.Label column md={4}>Task</Form.Label>
              <Col md={8}>
                <Form.Control as="select" name="task[]" multiple size={10} defaultValue={[]}>
                  <option value="">Select Tasks</option>
                  <option value="task1">Task One</option>
                  <option value="task2">Task Two</option>
                  <option value="task3">Task Three</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col md={4}></Col>
              <Col md={8}>
                <Form.Check
                  type="checkbox"
                  name="new_page"
                  id="open_tasks_new_page"
                  label="New Page Per Task"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col md={4}></Col>
              <Col md={8}>
                <Form.Check
                  type="checkbox"
                  name="hide_blocked"
                  id="open_tasks_hide_blocked"
                  label="Hide Blocked Tasks"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col md={4}></Col>
              <Col md={8}>
                <Form.Check
                  type="checkbox"
                  name="allow_unarrived"
                  id="open_tasks_allow_unarrived"
                  label="Include Unarrived Cases"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col md={4}></Col>
              <Col md={8}>
                <Form.Check
                  type="checkbox"
                  name="hide_provider"
                  id="open_tasks_hide_provider"
                  label="Hide Provider"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="open_tasks_format">
              <Form.Label column md={4}>Format <span className="text-danger">*</span></Form.Label>
              <Col md={8}>
                <Form.Control as="select" name="format" required defaultValue="">
                  <option value="">Select Format</option>
                  <option value="screen">On Screen</option>
                  <option value="csv">CSV (Excel)</option>
                  <option value="labels">Labels</option>
                  <option value="json">JSON</option>
                </Form.Control>
              </Col>
            </Form.Group>

           <Form.Group as={Row}>
             <Col sm={{ span: 8, offset: 4 }}>
               <Link to="/Addincompletetask">
                 <Button
                   id="pay-per-task-submit"
                   type="button"
                   variant="primary"
                   className="w-100 mt-2"
                   style={{
                     backgroundColor: '#004aad',
                     borderColor: '#004aad',
                     marginTop: '10px',
                   }}
                 >
                   Run
                 </Button>
               </Link>
             </Col>
           </Form.Group>
          </Form>
        </div>
      </div>
    
    </div>
  );
};

export default ReportForm;
